"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContractsSearch;
const react_1 = __importStar(require("react"));
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const ContractRowContent_1 = require("./ContractRowContent");
const ContractsController_1 = require("./ContractsController");
const ContractsFilterBody_1 = require("./ContractsFilterBody");
const ContractModalButtons_1 = require("./Modals/ContractModalButtons");
const ContractSigningRowActions_1 = require("../Signing/ContractSigningRowActions");
function ContractsSearch({ title }) {
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    return (react_1.default.createElement(FilterableTable_1.default, { id: "contracts", title: title, FilterBodyComponent: ContractsFilterBody_1.ContractsFilterBody, tableStructure: [
            // Wszystkie kolumny poza jedną zeszły do bloku kontraktu (decyzja właściciela
            // 2026-08-11, makieta `tmp/makieta-lista-kontraktow-v3.html`, wariant A):
            // „Projekt”, „Oznaczenie”, „Rozpoczęcie”, „Zakończenie”, „Gwarancja”, a także
            // kolumna znaczników z wcześniejszej wersji makiety. Umowę ENVI od umowy
            // wykonawcy odróżnia sam kształt wiersza — tak jak w widoku zadań.
            // colLg 11, nie 12: dwunasta kolumna musi zostać wolna na RowActionMenu
            // aktywnego wiersza, inaczej menu zawija się na nowy wiersz i ląduje po lewej
            // (powód opisany szerzej w LettersSearch.tsx).
            {
                header: "Kontrakt",
                renderTdBody: (contract) => (react_1.default.createElement(ContractRowContent_1.ContractRowContent, { contract: contract })),
                colLg: 11,
            },
        ], AddNewButtonComponents: [ContractModalButtons_1.OurContractAddNewModalButton, ContractModalButtons_1.OtherContractAddNewModalButton], EditButtonComponent: ContractModalButtons_1.ContractEditModalButton, RowActionMenuComponents: [ContractSigningRowActions_1.SignContractDocumentsButton, ContractSigningRowActions_1.UploadSignedContractDocumentButton], isDeletable: true, repository: ContractsController_1.contractsRepository, selectedObjectRoute: "/contract/", shouldRetrieveDataBeforeEdit: true }));
}
